<template>
    <div>
        <!-- 高级 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
            <h3>{{ $t('lang.smartsms.advancedConfiguration') }}</h3>
            <el-button size="mini" @click="refesh" type="primary">刷新</el-button>
        </div>
        <el-divider></el-divider>
        <el-form label-width="140px" :model="options">
            <el-form-item :label="$t('lang.ConfigSetting.Enable')">
                <el-checkbox v-model="options.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.debug')">
                <el-checkbox v-model="options.enable_debug"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.saveLogNumber')">
                <el-input class="input" size="mini" v-model="options.log_file_num"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.logSize')">
                <el-input class="input" size="mini" v-model="options.log_file_size"></el-input>
                <p class="tips">KB</p>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.logPriority')">
                <el-select v-model="options.log_priority" size="mini">
                    <el-option v-for="item in LogPriorityList" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.log')">
                <el-button type="danger" @click="downloadLog" size="mini">{{ $t('lang.smartlink.download') }}</el-button>
            </el-form-item>
        </el-form>
        <div class="foot">
            <el-button size="mini" type="primary" @click="saveAdvanced">{{ $t('lang.IOControl.SaveApply') }}</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            LogPriorityList: [
                { value: '8', label: this.$t('lang.smartlink.debug') },
                { value: '7', label: this.$t('lang.smartlink.info') },
                { value: '6', label: this.$t('lang.smartlink.notice') },
                { value: '5', label: this.$t('lang.smartlink.alarm') },
                { value: '4', label: this.$t('lang.smartlink.error') },
                { value: '3', label: this.$t('lang.smartlink.deadly') },
                { value: '2', label: this.$t('lang.smartlink.alert') },
                { value: '1', label: this.$t('lang.smartlink.emergency') }
            ],
            options: {}
        };
    },
    methods: {
        saveAdvanced() {
            this.$emit('saveAdvanced', {
                ...this.options,
                enabled: this.options.enabled ? 1 : 0,
                enable_debug: this.options.enable_debug ? 1 : 0
            })
        },
        downloadLog() {
            this.$emit('downloadLog')
        },
        refesh() {
            this.$emit('refesh')
        }
    },
};
</script>
<style scoped>
h3 {
    font-size: 16px;
}

.input {
    width: 320px;
}

.tips {
    color: #999;
    font-size: 12px;
}

.foot {
    display: flex;
    justify-content: end;
}
</style>